import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import type { ReactNode } from "react";

import * as css from "./Sticky.css";

type Props = {
  children: ReactNode;
  className?: string;
  asChild?: boolean;
};

export function Sticky({ children, className, asChild }: Props) {
  const Component = asChild ? Slot : "div";
  return (
    <Component className={clsx(css.sticky, className)}>{children}</Component>
  );
}
